var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevenue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.951,
    height: 27.208,
    viewBox: "0 0 31.951 27.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.25 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.257,7.715c-4.822,0-9.949-1.352-9.949-3.857S7.435,0,12.257,0s9.951,1.353,9.951,3.858S17.08,7.715,12.257,7.715m0-6.528c-5.428,0-8.762,1.557-8.762,2.671s3.334,2.67,8.762,2.67,8.764-1.556,8.764-2.67-3.335-2.671-8.764-2.671",
    transform: "translate(0.431 0)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.257,7.2C7.435,7.2,2.308,5.85,2.308,3.344a.593.593,0,1,1,1.187,0c0,1.114,3.334,2.67,8.762,2.67s8.764-1.556,8.764-2.67a.593.593,0,1,1,1.187,0c0,2.505-5.128,3.857-9.951,3.857",
    transform: "translate(0.431 0.514)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.257,10.306c-4.822,0-9.949-1.352-9.949-3.857a.593.593,0,1,1,1.187,0c0,1.114,3.334,2.67,8.762,2.67.544,0,1.078-.017,1.6-.047a.593.593,0,0,1,.071,1.184c-.54.033-1.1.05-1.667.05",
    transform: "translate(0.431 1.094)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9,7.616a.594.594,0,0,1-.593-.593V3.381a.593.593,0,0,1,1.187,0V7.022a.594.594,0,0,1-.593.593",
    transform: "translate(0.431 0.521)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.668,7.236a.594.594,0,0,1-.593-.593V3.381a.593.593,0,0,1,1.187,0V6.643a.594.594,0,0,1-.593.593",
    transform: "translate(3.376 0.521)",
    fill: "#4f9ad6",
    stroke: "#4f9ad6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.536,16.157h-.015c-4.4-.113-7.9-1.214-8.927-2.809a.594.594,0,1,1,1-.642c.668,1.042,3.616,2.154,7.958,2.264a.593.593,0,0,1-.015,1.187",
    transform: "translate(0.467 2.322)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.708,19.381c-5.113,0-10.4-1.441-10.4-3.852a.593.593,0,1,1,1.187,0c0,1.061,3.674,2.665,9.213,2.665a.593.593,0,1,1,0,1.187",
    transform: "translate(0.431 2.789)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.949,11.782C5.126,11.782,0,10.431,0,7.925c0-.8.536-1.951,3.093-2.853a.593.593,0,0,1,.394,1.119c-1.419.5-2.3,1.165-2.3,1.734,0,1.114,3.334,2.67,8.762,2.67a25.046,25.046,0,0,0,3.122-.19.593.593,0,0,1,.148,1.177,26.273,26.273,0,0,1-3.271.2",
    transform: "translate(0 0.941)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.949,14.526C5.126,14.526,0,13.175,0,10.669a.593.593,0,0,1,1.187,0c0,1.114,3.334,2.67,8.762,2.67.714,0,1.428-.028,2.116-.084a.6.6,0,0,1,.64.542.592.592,0,0,1-.542.64c-.72.059-1.466.089-2.213.089",
    transform: "translate(0 1.882)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.593,11.836A.594.594,0,0,1,0,11.242V7.6a.593.593,0,0,1,1.187,0v3.641a.594.594,0,0,1-.593.593",
    transform: "translate(0 1.309)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9,16.9a.594.594,0,0,1-.593-.593V13.115a.593.593,0,1,1,1.187,0v3.194A.594.594,0,0,1,2.9,16.9",
    transform: "translate(0.431 2.339)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.684,25.636a9.949,9.949,0,1,1,9.95-9.95,9.961,9.961,0,0,1-9.95,9.95m0-18.712a8.762,8.762,0,1,0,8.763,8.762,8.773,8.773,0,0,0-8.763-8.762",
    transform: "translate(1.818 1.072)",
    fill: "#002a2e",
    stroke: "#002a2e",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.dc44b2502d013b7cf31643ff8f8390ad.svg";
export { ForwardRef as ReactComponent };